import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconPlaceholder(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path d="M3 20V16H5V19H8V21H4C3.44772 21 3 20.5523 3 20Z" fill="currentColor" />
      <path d="M5 5V8H3V4C3 3.44772 3.44772 3 4 3H8V5H5Z" fill="currentColor" />
      <path d="M16 5V3H20C20.5523 3 21 3.44772 21 4V8H19V5H16Z" fill="currentColor" />
      <path d="M19 19V16H21V20C21 20.5523 20.5523 21 20 21H16V19H19Z" fill="currentColor" />
      <path
        d="M17 12C17 12.5523 16.5523 13 16 13H13.0005V16C13.0005 16.5523 12.5527 17 12.0005 17C11.4482 17 11.0005 16.5523 11.0005 16V13H8C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11H11.0005L11.0005 8C11.0005 7.44772 11.4482 7 12.0005 7C12.5527 7 13.0005 7.44772 13.0005 8V11H16C16.5523 11 17 11.4477 17 12Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
